import { Permission } from "./permission.model";

export class PositionRole {
	position: number;
	permissions: Permission[];
	user!: number;
}

export class Position {
	id: number;
	department: number;
	name: string;
	company: number;
	superior: number;
}

export class AdminPositionRequest {
	id?: number;
	department: number;
	name: string;
	superior?: number;
}